import { centsToDisplay } from '@archetelos/lib/currency';

// All money math in integer cents. Per spec.

export const STANDARD_MONTHLY_CENTS = 800;
export const STANDARD_ANNUAL_CENTS = 8000;

// Founder first cycle (50% off, applied once).
export const FOUNDER_MONTHLY_FIRST_CYCLE_CENTS = 400;
export const FOUNDER_ANNUAL_FIRST_CYCLE_CENTS = 4000;

// Founder ongoing (25% loyalty, applied forever after).
export const FOUNDER_MONTHLY_LOYALTY_CENTS = 600;
export const FOUNDER_ANNUAL_LOYALTY_CENTS = 6000;

export interface TierDisplay {
  tier: 'monthly' | 'annual';
  firstCycleCents: number;
  ongoingCents: number;
  firstCycleDisplay: string;
  ongoingDisplay: string;
}

export function computeTierDisplay(args: {
  tier: 'monthly' | 'annual';
  isFounder: boolean;
}): TierDisplay {
  const { tier, isFounder } = args;
  if (tier === 'monthly') {
    const first = isFounder ? FOUNDER_MONTHLY_FIRST_CYCLE_CENTS : STANDARD_MONTHLY_CENTS;
    const ongoing = isFounder ? FOUNDER_MONTHLY_LOYALTY_CENTS : STANDARD_MONTHLY_CENTS;
    return {
      tier,
      firstCycleCents: first,
      ongoingCents: ongoing,
      firstCycleDisplay: centsToDisplay(first),
      ongoingDisplay: centsToDisplay(ongoing),
    };
  }
  const first = isFounder ? FOUNDER_ANNUAL_FIRST_CYCLE_CENTS : STANDARD_ANNUAL_CENTS;
  const ongoing = isFounder ? FOUNDER_ANNUAL_LOYALTY_CENTS : STANDARD_ANNUAL_CENTS;
  return {
    tier,
    firstCycleCents: first,
    ongoingCents: ongoing,
    firstCycleDisplay: centsToDisplay(first),
    ongoingDisplay: centsToDisplay(ongoing),
  };
}
